/* Gsap */
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin);

export default class Anime {
	
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.scrollTrigger = this.hasScrolltrigger() ? true : false;
		this.type = this.el.dataset.hwcAnime;
		this.delay = (this.el.dataset.animeDelay && typeof(this.el.dataset.animeDelay) !== 'undefined') ? this.el.dataset.animeDelay : null;
		
		this.el = this.el.dataset.animeChildren
			? Array.from(this.el.children)
			: this.el;
		this.stagger = 0.1;
		

		switch (this.type) { 
			case "lines":
				this.drawLines();
				break;
			case "imagesscaled":
				this.imagesScaled();
			case "title":
				this.revealTitle();
				break; 
			case "fadeInImages":
				this.fadeInImages();
				break; 
			case "translateY":
				this.translateY();
				break; 
			case "number":
				this.numberCount();
				break; 
			default:
				break;
		}

		this.toggleClass();
	}

	imagesScaled() {
		const images = this.el.querySelectorAll(".hwc-Picture");
		const finalRotations = Array.from(
			images,
			(img) => gsap.getProperty(img, "rotation") || 0
		);

		images.forEach((img, i) => {
			gsap.set(img, {
				scale: 0,
				autoAlpha: 0,
				rotation: finalRotations[i] + 30,
				transformOrigin: "50% 50%",
			});
		});

		gsap.to(images, {
			scale: 1,
			autoAlpha: 1,
			rotation: (i) => finalRotations[i],
			ease: "power4.out",
			stagger: {
				each: 0.5,
			},
			duration: 1,
			scrollTrigger: {
				trigger: this.el,
				start: "top 80%",
			},
		});
	}

	drawLines() {
		const line = this.el.querySelector(".line-anime path");

		const length = line.getTotalLength();
		line.style.strokeDasharray = length;
		line.style.strokeDashoffset = length;
		line.style.visibility = "visible";

		gsap.to(line, {
			strokeDashoffset	: 0,
			duration			: 2,
			scrollTrigger		: {
				trigger	: line,
				start	: "top bottom-=200",
				end		: "bottom+=200 top",
				scrub	: 1,
			},
		});
	}

	numberCount() {

		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger	: this.el,
				start	: "top bottom",
				end		: "bottom top",
			};
		}

		var thatDelay = this.delay ? this.delay : 0;
		gsap.fromTo(
			this.el,
			{
				autoAlpha 		: 0,
				y				: 56,
				yPercent		: 0,
				force3D			: false,
			},
			{
				scrollTrigger	: this.scrollTrigger,
				ease			: "expo.out",
				y				: 0,
				autoAlpha		: 1,
				yPercent		: 0,
				force3D			: false,
				duration		: 2,
				stagger			: this.stagger,
				delay			: thatDelay			
			}
		);

        const counters = this.el.querySelectorAll("[data-anime-number]");
		const speed = 200;

		counters.forEach((item) => {
			const animate = () => {
				const value = Number(item.dataset.animeNumber);
				const data = Number(item.innerText);

				const time = value / speed;
				if (data < value) {
					item.innerText = Math.ceil(data + time);
					setTimeout(animate, 1);
				} else {
					item.innerText = value;
				}
			};
			animate();
		});

	}

	translateY() {
		
		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger	: this.el,
				start	: "top bottom",
				end		: "bottom top",
			};
		}

		var thatDelay = this.delay ? this.delay : 0;
		gsap.fromTo(
			this.el,
			{
				autoAlpha 		: 0,
				y				: 56,
				yPercent		: 0,
				force3D			: false,
			},
			{
				scrollTrigger	: this.scrollTrigger,
				ease			: "expo.out",
				y				: 0,
				autoAlpha		: 1,
				yPercent		: 0,
				force3D			: false,
				duration		: 2,
				stagger			: this.stagger,
				delay			: thatDelay			
			}
		);
	}

	fadeInImages() {
		
		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger	: this.el,
				start	: "top bottom",
				end		: "bottom top",
			};
		}

		var thatDelay = this.delay ? this.delay : 0;
		gsap.fromTo(
			this.el,
			{
				autoAlpha 		: 0,
				force3D			: false,
			},
			{
				scrollTrigger	: this.scrollTrigger,
				ease			: "expo.out",				
				autoAlpha		: 1,				
				force3D			: false,
				duration		: 2,
				stagger			: this.stagger,
				delay			: thatDelay			
			}
		);
	}
  

	revealTitle() {
		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger: this.el,
				start: "clamp(top bottom)",
			};
		}

		SplitText.create(this.el, {
			type: "words, chars",
			autoSplit: true,
			onSplit: (self) => {
				gsap.fromTo(
					self.chars,
					{
						autoAlpha: 0,
						y: 10,
						filter: () => `blur(${gsap.utils.random(6, 14)}px)`,
					},
					{
						autoAlpha: 1,
						y: 0,
						filter: "blur(0px)",
						duration: 1,
						ease: "power2.out",
						stagger: {
							each: 0.05,
							from: "random",
						},
						scrollTrigger: this.scrollTrigger,
					}
				);
			},
		});
	}
 

	toggleClass() {
		ScrollTrigger.create({
			trigger: this.el,
			start: "+=100px bottom",
			onToggle: (self) => {
				if (self.isActive) {
					this.el.length
						? this.el.forEach((el) => el.classList.add("anime-initialized"))
						: this.el.classList.add("anime-initialized");
				}
			},
		});
	}

	hasScrolltrigger() {
		return window.innerHeight < this.el.getBoundingClientRect().top
			? true
			: false;
	}
}
